import { render, staticRenderFns } from "./RecordControlBar.vue?vue&type=template&id=3648023d&scoped=true&"
import script from "./RecordControlBar.vue?vue&type=script&lang=js&"
export * from "./RecordControlBar.vue?vue&type=script&lang=js&"
import style0 from "./RecordControlBar.vue?vue&type=style&index=0&id=3648023d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3648023d",
  null
  
)

export default component.exports